import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { MapPin, Square, Play } from 'lucide-react';

const OurProjects = () => {
  const { language } = useLanguage();
  const [activeFilter, setActiveFilter] = useState('all');
  const [playingVideo, setPlayingVideo] = useState(null);

  const content = {
    ru: {
      title: 'Наши проекты',
      subtitle: 'Мы гордимся нашей работой — более 100 реализованных объектов в РК',
      filters: {
        all: 'Все проекты',
        education: 'Образование',
        commercial: 'Госучреждение',
        horeca: 'Коммерческие',
        residential: 'Жилые комплексы'
      }
    },
    kz: {
      title: 'Біздің жобалар',
      subtitle: 'ҚР бойынша 100-ден астам іске асырылған объект',
      filters: {
        all: 'Барлық жобалар',
        education: 'Білім беру',
        commercial: 'Мемлекеттік мекеме',
        horeca: 'Коммерциялық',
        residential: 'Тұрғын кешендер'
      }
    },
    en: {
      title: 'Our Projects',
      subtitle: 'Over 100 completed projects in Kazakhstan',
      filters: {
        all: 'All Projects',
        education: 'Education',
        commercial: 'Government',
        horeca: 'Commercial',
        residential: 'Residential'
      }
    },
    ar: {
      title: 'مشاريعنا',
      subtitle: 'أكثر من 100 مشروع مكتمل في كازاخستان',
      filters: {
        all: 'جميع المشاريع',
        education: 'تعليمي',
        commercial: 'حكومي',
        horeca: 'تجاري',
        residential: 'سكني'
      }
    }
  };

  const projects = [
    {
      id: 1,
      title: { ru: '«Комфортная школа»', kz: '«Комфортты мектеп»', en: 'Comfortable School', ar: 'مدرسة مريحة' },
      description: { ru: 'Крупнейший проект — 22 000 м².', kz: 'Ең ірі жоба — 22 000 м².', en: 'Largest project — 22,000 m².', ar: 'أضخم مشروع — 22,000 م².' },
      location: { ru: 'Астана', kz: 'Астана', en: 'Astana', ar: 'أستانا' },
      category: 'education',
      type: 'video',
      reelId: 'DPoMR9YiIKY',
      videoUrl: null,
      thumbnail: '/images/video/thumb_school_comfort.jpg',
      area: '22 000'
    },
    {
      id: 2,
      title: { ru: 'Департамент госдоходов', kz: 'Мемлекеттік кірістер департаменті', en: 'State Revenue Department', ar: 'دائرة الإيرادات الحكومية' },
      description: { ru: 'Административное здание.', kz: 'Әкімшілік ғимарат.', en: 'Administrative building.', ar: 'مبنى إداري.' },
      location: { ru: 'Павлодар', kz: 'Павлодар', en: 'Pavlodar', ar: 'بافلودار' },
      category: 'commercial',
      type: 'video',
      reelId: 'DS-HysFCPnu',
      videoUrl: null,
      thumbnail: '/images/video/thumb_tax.jpg',
      area: '7 000'
    },
    {
      id: 3,
      title: { ru: 'ЖК от BAZIS A', kz: 'BAZIS A ТК', en: 'BAZIS A Residential', ar: 'مجمع BAZIS A السكني' },
      description: { ru: 'Жилой комплекс премиум-класса.', kz: 'Премиум-класс тұрғын кешені.', en: 'Premium residential complex.', ar: 'مجمع سكني فاخر.' },
      location: { ru: 'Алматы', kz: 'Алматы', en: 'Almaty', ar: 'ألماتي' },
      category: 'residential',
      type: 'video',
      reelId: 'DA57FzytlUL',
      videoUrl: null,
      thumbnail: '/images/video/thumb_panels_jk.jpg',
      area: '20 000'
    },
    {
      id: 4,
      title: { ru: 'Реконструкция Атырау Акпарат', kz: 'Атырау Ақпарат қайта құру', en: 'Atyrau Akparat Reconstruction', ar: 'إعادة إعمار أتيراو أقبارات' },
      description: { ru: 'Государственное учреждение.', kz: 'Мемлекеттік мекеме.', en: 'Government building.', ar: 'مبنى حكومي.' },
      location: { ru: 'Атырау', kz: 'Атырау', en: 'Atyrau', ar: 'أتيراو' },
      category: 'commercial',
      type: 'video',
      reelId: 'DRy2UALCBGW',
      videoUrl: null,
      thumbnail: '/images/video/thumb_atyrau.jpg',
      area: '6 000'
    },
    {
      id: 5,
      title: { ru: 'Бизнес центр', kz: 'Бизнес орталық', en: 'Business Center', ar: 'مركز الأعمال' },
      description: { ru: 'Современный офисный интерьер.', kz: 'Заманауи кеңсе интерьері.', en: 'Modern office interior.', ar: 'تصميم داخلي عصري للمكاتب.' },
      location: { ru: 'Костанай', kz: 'Қостанай', en: 'Kostanay', ar: 'قُسطاناي' },
      category: 'horeca',
      type: 'video',
      reelId: 'DQlaKRUCC_g',
      videoUrl: null,
      thumbnail: '/images/video/thumb_stylish_office.jpg',
      area: '3 000'
    },
    {
      id: 6,
      title: { ru: 'Институт глазных болезней', kz: 'Көз аурулары институты', en: 'Eye Disease Institute', ar: 'معهد أمراض العيون' },
      description: { ru: 'Медицинское учреждение.', kz: 'Медициналық мекеме.', en: 'Medical institution.', ar: 'مؤسسة طبية.' },
      location: { ru: 'Алматы', kz: 'Алматы', en: 'Almaty', ar: 'ألماتي' },
      category: 'commercial',
      type: 'video',
      reelId: 'C91K2Rot5xk',
      videoUrl: null,
      thumbnail: '/images/video/thumb_medical.jpg',
      area: '5 000'
    },
    {
      id: 7,
      title: { ru: 'Вахтовый городок', kz: 'Вахталық қалашық', en: 'Rotational camp', ar: 'مخيم العمال الدوري' },
      description: { ru: 'Образовательное учреждение.', kz: 'Білім беру мекемесі.', en: 'Educational institution.', ar: 'مؤسسة تعليمية.' },
      location: { ru: 'Астана', kz: 'Астана', en: 'Astana', ar: 'أستانا' },
      category: 'education',
      type: 'video',
      reelId: 'DSpYwrliL7a',
      videoUrl: null,
      thumbnail: '/images/video/thumb_camp.jpg',
      area: '15 000'
    },
    {
      id: 8,
      title: { ru: 'Школа нового поколения NGS', kz: 'Жаңа буын мектебі NGS', en: 'New Generation School NGS', ar: 'مدرسة الجيل الجديد NGS' },
      description: { ru: 'Спортзал, бассейн, столовая.', kz: 'Спорт залы, бассейн, асхана.', en: 'Gym, pool, cafeteria.', ar: 'صالة رياضية، مسبح، كافيتيريا.' },
      location: { ru: 'Астана', kz: 'Астана', en: 'Astana', ar: 'أستانا' },
      category: 'education',
      type: 'video',
      reelId: 'DRhMb84CO77',
      videoUrl: null,
      thumbnail: '/images/video/thumb_school.jpg',
      area: '10 000'
    }
  ];

  const t = content[language] || content.en || content.ru;

  const categoryColors = {
    education: 'bg-[#061d36]',
    commercial: 'bg-[#061d36]',
    horeca: 'bg-[#061d36]',
    residential: 'bg-[#061d36]'
  };

  const filteredProjects = activeFilter === 'all' ? projects : projects.filter(p => p.category === activeFilter);

  return (
    <section className="pt-6 py-2 pb-6 bg-[#061d36]">
      <div className="container mx-auto px-4">
        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-3">{t.title}</h2>
          <p className="text-white/70">{t.subtitle}</p>
        </div>

        {/* Filter */}
        <div className="flex flex-wrap justify-center gap-2 mb-10">
          {Object.entries(t.filters).map(([key, label]) => (
            <button
              key={key}
              onClick={() => setActiveFilter(key)}
              className={`px-5 py-2.5 rounded-full text-sm font-medium transition-all ${
                activeFilter === key
                  ? 'bg-[#8b4444] text-white shadow-md'
                  : 'bg-white/10 text-white/80 hover:bg-white/20 border border-white/20'
              }`}
            >
              {label}
            </button>
          ))}
        </div>

        {/* Projects Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto">
          {filteredProjects.map((project) => (
            <div key={project.id} className="group bg-[#F5F5F0] rounded-2xl overflow-hidden hover:shadow-xl transition-all">
              <div className="relative h-72 overflow-hidden bg-[#061d36]">
                {playingVideo === project.id ? (
                  <iframe
                    src={`https://www.instagram.com/reel/${project.reelId}/embed/`}
                    className="w-full h-full"
                    frameBorder="0"
                    scrolling="no"
                    allowFullScreen
                    title={project.title[language]}
                  />
                ) : (
                  <div 
                    className="w-full h-full cursor-pointer relative"
                    onClick={() => setPlayingVideo(project.id)}
                  >
                    <img 
                      src={project.thumbnail} 
                      alt={project.title[language]} 
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                    <div className="absolute inset-0 flex items-center justify-center">
                      <div className="w-12 h-12 bg-white/90 rounded-full flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform">
                        <Play className="w-5 h-5 text-[#061d36] ml-0.5" />
                      </div>
                    </div>
                  </div>
                )}
                <div className={`absolute top-3 right-3 ${categoryColors[project.category]} text-white text-xs font-medium px-3 py-1 rounded`}>
                  {t.filters[project.category]}
                </div>
              </div>
              <div className="p-5">
                <div className="flex items-center text-sm text-gray-500 mb-2">
                  <MapPin className="w-4 h-4 mr-1" />
                  {project.location[language]}
                </div>
                <h3 className="text-lg font-bold text-[#061d36] mb-2">{project.title[language]}</h3>
                <p className="text-[#061d36]/70 text-sm mb-3">{project.description[language]}</p>
                <div className="flex items-center text-sm">
                  <Square className="w-4 h-4 mr-1 text-gray-400" />
                  <span className="font-semibold text-[#061d36]">{project.area} м²</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurProjects;
